import type { MouseEvent } from 'react';
import { StyledCardSelectButton } from './CardSelectButton.styles';
import type { CardSelectButtonProps } from './CardSelectButton.types';

export function CardSelectButton({
  children,
  onSelect,
  'aria-label': ariaLabel,
  'aria-pressed': ariaPressed,
}: CardSelectButtonProps) {
  return (
    <StyledCardSelectButton
      type="button"
      data-card-select=""
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onSelect();
      }}
    >
      {children}
    </StyledCardSelectButton>
  );
}
